import { useMediaQuery } from "usehooks-ts";

import { MOBILE_QUERY } from "@/components/layout/layout.constants";

/**
 * How a sidebar renders for the current viewport and open state. Shared by
 * the main menu and the settings sidebar so both collapse and overlay alike.
 *
 * @param isDesktop viewport is desktop-width — the sidebar is in-flow (icon-rail
 *   collapsible) at/above it, a fixed overlay drawer below it.
 */
export function useSidebarMode(isSidebarOpen: boolean, isDesktop: boolean) {
  // Phone-only: even an open overlay never shows the collapsed icon-rail.
  const isMobile = useMediaQuery(MOBILE_QUERY);
  // Below desktop the sidebar is a fixed overlay; at/above it, in-flow.
  const isOverlay = !isDesktop;
  // On overlay, only the phone case forces expanded (never icon-rail).
  const isCollapsed = isMobile ? false : !isSidebarOpen;
  return { isCollapsed, isOverlay };
}
